import React, {useState, useCallback} from 'react'
import {
  DockComponent,
  DockProps,
  DocksStateContextProps,
  DocksActionsContext,
  DocksStateContext,
} from './DocksContext'

type Props = {
  children: React.ReactNode
}

function DocksContextProvider(props: Props) {
  const [state, setState] = useState<DocksStateContextProps>({dock: null})

  const open = useCallback(function<T>(component: DockComponent<T>, props: DockProps<T>) {
    setState(state => ({...state, dock: {component, props}}))
  }, [])

  const close = useCallback(function() {
    setState(state => ({...state, Dock: null}))
  }, [])

  return (
    <DocksActionsContext.Provider value={{open, close}}>
      <DocksStateContext.Provider value={state}>{props.children}</DocksStateContext.Provider>
    </DocksActionsContext.Provider>
  )
}

export default DocksContextProvider
